import { render } from "./additions-tab.vue?vue&type=template&id=6299f794"
import script from "./additions-tab.vue?vue&type=script&lang=js"
export * from "./additions-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__